import React from "react";

export default (props) => {
  const { className } = props;
  return <div className={`mb-2 ${className}`} {...props} />;
};
